<template>
  <li v-if="point" class="start__route-item" :class="{'start__route-item--active': anyShownItems}">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="start__route-title">Подъезд {{ point.entrance }}</div>
          <div v-if="anyShownItems" @click="hideItems" class="start__route-close start__route-close-form"></div>
          <div class="start__list-btn">
            <div class="start__comment" @click="showItem('comment')"></div>
            <div class="start__problem" @click="showItem('problem')"></div>
            <div class="start__add-point" @click="showItem('flats')">OK</div>
            <div v-if="anyShownItems" class="start__form-wrap">
              <form v-if="items.comment" @submit.prevent="updateComment" action="#" class="start__comment-form">
                <label class="has-float-label">
                  <textarea v-model="point.comment" required class="start__comment-input"
                            placeholder="Написать..."></textarea>
                  <span>Комментарий</span>
                </label>
                <input type="submit" class="start__submit">
              </form>
              <form v-if="items.problem" @submit.prevent="updateProblem" action="#" class="start__problem-form">
                <select v-model="point.problemId" required class="start__problem-select">
                  <option :value="null" disabled>Выберите проблему</option>
                  <option :value="choice.id" v-for="choice in problems" v-bind:key="choice.id">
                    {{ choice.name }}
                  </option>
                </select>
                <input type="submit" class="start__submit">
              </form>
              <form v-if="items.flats" action="#" @submit.prevent="updateFlats" class="start__add-point-form">
                 <label class="has-float-label">
                  <input required type="text" class="start__add-point-input" placeholder="Кол-во квартир"
                         v-model="point.numPromoFlats">
                   <span>Кол-во квартир</span>
                 </label>
                 <label class="has-float-label">
                   <input required type="text" class="start__add-point-input" placeholder="Ключ"
                         v-model="point.key">
                   <span>Ключ</span>
                 </label>
                 <MaterialSet ref="materialSet" :choices="routeSummary.materials" :materials="point.materials"/>
                 <input type="submit" class="start__submit">
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import $backend from '../backend'
import MaterialSet from '@/components/MaterialSet.vue'

export default {
  name: 'Point',
  props: {
    routeSummary: Object,
    point: Object,
    problems: Array
  },
  data () {
    return {
      items: {
        'problem': false,
        'comment': false,
        'materials': false,
        'flats': false
      }
    }
  },
  components: {
    MaterialSet
  },
  computed: {
    anyShownItems () {
      return Object.keys(this.items).some((key, index, array) => this.items[key])
    }
  },
  methods: {
    updatePoint (item, data) {
      let url = `/points/${item}/${this.routeSummary.routeId}/${this.point.pointId}`
      this.$emit('startUpdate')
      return $backend.postData(url, data)
        .then(data => {
          this.$emit('changed', this.point)
          this.hideItem(item)
        }).finally(() => {
          this.$emit('endUpdate')
        })
    },
    updateComment () {
      this.updatePoint('comment', { comment: this.point.comment })
    },
    updateProblem () {
      this.updatePoint('problem', { problemId: this.point.problemId, intercomId: '' })
    },
    updateFlats () {
      let baseCondition = (this.point.numPromoFlats > 0) && this.point.key
      if (!baseCondition) {
        this.$swal({ type: 'error', text: 'Неверно указано кол-во квартир или не заполнен ключ.' })
        return
      }

      let [isValid, materials] = this.$refs.materialSet.validate()
      if (!isValid) {
        return
      }
      this.updatePoint('flats', {
        numPromoFlats: this.point.numPromoFlats,
        key: this.point.key,
        materials: materials })
    },
    hideItems () {
      Object.keys(this.items).map((item, index) => {
        this.hideItem(item)
      })
    },
    showItem (item) {
      this.hideItems()
      this.items[item] = true
    },
    hideItem (item) {
      this.items[item] = false
    }
  }
}
</script>
